var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetroBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.925,
    height: 17.138,
    viewBox: "0 0 13.925 17.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-bin",
    "data-name": "Icon metro-bin",
    d: "M3.57,6.427V17.138a1.074,1.074,0,0,0,1.071,1.071h9.64a1.074,1.074,0,0,0,1.071-1.071V6.427H3.57Zm3.213,9.64H5.713v-7.5H6.784Zm2.142,0H7.855v-7.5H8.926Zm2.142,0H10v-7.5h1.071Zm2.142,0H12.139v-7.5h1.071Zm2.41-12.854H12.139V1.874a.806.806,0,0,0-.8-.8H7.587a.806.806,0,0,0-.8.8V3.213H3.3a.806.806,0,0,0-.8.8V5.356H16.424V4.017a.806.806,0,0,0-.8-.8Zm-4.552,0H7.855V2.156h3.213V3.213Z",
    transform: "translate(-2.499 -1.071)",
    fill: "#d6d6d6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetroBin);
export default __webpack_public_path__ + "static/media/metro-bin.e051dbf25e5addbcf20b803c497e8ef8.svg";
export { ForwardRef as ReactComponent };